<script>

// export let bg_color = "#f9f9fa";
// export let pt = "0px";
// export let pb = "0px";
// export let pl = "0px";
// export let pr = "0px";
export let desktop_styles = "";
export let mobile_styles = "";
export let div_id = "";

let page_width;

</script>

<svelte:window bind:outerWidth={page_width}/>

{#if page_width > 1023}
<div id="{div_id !== '' ? div_id : ''}" class="sbox-container" style="{desktop_styles}">
    <div class="sbox-child-container">
        <slot/>
    </div>
</div>
{:else}    
<div id="{div_id !== '' ? div_id : ''}"  class="sbox-container" style="{mobile_styles}">
    <div class="sbox-child-container">
        <slot/>
    </div>
</div>
{/if}


<style>

    .sbox-container {
        width: 100% !important;
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: relative;
    }

    .sbox-child-container {
        width: 1400px;
        position: relative;
    }

@media (max-device-width: 1024px), (max-width: 1023px) {

    .sbox-child-container {
        width: 100%;
        /* margin-left: 20px !important; */
        /* margin-right: 20px !important; */
        
    }

}

</style>